import { useMemo } from 'react';

import { createFilterHelper } from '@kc-console/shared-ui';

import { getEventStatusLabelMap } from '../model/getEventStatusVariant';
import { EventStatus } from '../model/types';

import type { FilterDefBase } from '@kc-console/shared-ui';

const filterHelper = createFilterHelper();

const eventStatusLabelMap = getEventStatusLabelMap();

const STATUS_OPTIONS = [
  { label: eventStatusLabelMap[EventStatus.Opened], value: EventStatus.Opened },
  { label: eventStatusLabelMap[EventStatus.Processing], value: EventStatus.Processing },
  { label: eventStatusLabelMap[EventStatus.Resolved], value: EventStatus.Resolved },
];

/**
 * 이벤트 테이블 필터 정의 훅.
 * @description
 * - 제목(title) 속성 텍스트 필터 + 상태(eventStatus) 컬렉션 필터를 제공한다.
 * - 조회 기간(날짜) 필터는 테이블 상단의 별도 날짜 필터(EventDateFilter)에서 관리한다.
 * @example
 * const filters = useEventFilters();
 */
const useEventFilters = (): FilterDefBase[] => {
  return useMemo(() => {
    return [
      filterHelper.property([
        filterHelper.propertyText({
          id: 'title',
          label: '이벤트',
          enableMultiSelect: false,
        }),
      ]),
      filterHelper.collection({
        id: 'eventStatus',
        label: '상태',
        options: STATUS_OPTIONS,
        enableMultiSelect: false,
        comparator: 'exact',
      }),
    ];
  }, []);
};

export default useEventFilters;
